const marketingEn = {
  "nav.campaigns": "Campaigns",
  "nav.automations": "Automations",
  "nav.feeds": "Product feeds",
  "nav.seo": "SEO",
  "palette.action.campaign": "Create email campaign",

  // abandoned checkouts: reminders
  "ab.col.reminders": "Reminders",
  "ab.reminders_sent": "{n} sent",
  "ab.no_reminders": "None",
  "ab.clicked": "Clicked",
  "ab.clicked_on": "clicked {when}",
  "ab.reminder_settings": "Reminder settings",
  "ab.send_reminder": "Send reminder email",
  "ab.reminder_sent": "Reminder sent",
  "ab.reminder_status": "{n} reminders sent, the last on {when}",
  "ab.whatsapp": "Send on WhatsApp",
  "ab.whatsapp_text": "Hi {name}, you left some items in your cart. You can complete your order here: {url}",

  // marketing overview
  "mkt.description": "See what your campaigns, automations and channels bring in.",
  "mkt.overview": "Overview",
  "mkt.campaigns": "Campaigns",
  "mkt.automations": "Automations",
  "mkt.feeds": "Product feeds",
  "mkt.kpi.sessions": "Sessions",
  "mkt.kpi.orders": "Orders",
  "mkt.kpi.sales": "Sales",
  "mkt.kpi.conversion": "Conversion rate",
  "mkt.email_results": "Email marketing",
  "mkt.recovery_results": "Abandoned checkout recovery",
  "mkt.rec.abandoned": "Abandoned checkouts",
  "mkt.rec.reminded": "Reminded",
  "mkt.rec.recovered": "Recovered",
  "mkt.rec.sales": "Recovered sales",
  "mkt.see_automations": "See automations",
  "mkt.channels": "Channels and campaigns",
  "mkt.channels_hint": "Sessions, orders and sales by where visitors came from (UTM tags and referrers).",
  "mkt.col.source": "Source / medium",
  "mkt.col.campaign": "Campaign",
  "mkt.quota": "Marketing emails this month",
  "mkt.utm.title": "Campaign link builder",
  "mkt.utm.hint": "Tag the links you share on social media, ads and with influencers so their sales show up here.",
  "mkt.utm.page": "Page",
  "mkt.utm.page_hint": "A store path like /collections/sale, or a full link.",
  "mkt.utm.source": "Source",
  "mkt.utm.medium": "Medium",
  "mkt.utm.campaign": "Campaign name",
  "mkt.utm.content": "Content",
  "mkt.utm.term": "Term",
  "mkt.utm.result": "Campaign link",

  // campaigns
  "mkt.new_campaign": "Create campaign",
  "mkt.no_campaigns": "Send your first email campaign",
  "mkt.no_campaigns_body": "Announce new products and sales to customers who agreed to get your emails. You'll see opens, clicks and the sales each campaign brings.",
  "mkt.col.status": "Status",
  "mkt.col.sent": "Sent",
  "mkt.col.open_rate": "Open rate",
  "mkt.col.click_rate": "Click rate",
  "mkt.col.sales": "Sales",
  "mkt.status.draft": "Draft",
  "mkt.status.scheduled": "Scheduled",
  "mkt.status.sending": "Sending",
  "mkt.status.sent": "Sent",
  "mkt.status.cancelled": "Stopped",
  "mkt.scheduled_for": "Scheduled for {when}",
  "mkt.sent_on": "Sent {when}",
  "mkt.edited": "Edited {when}",
  "mkt.duplicate": "Duplicate",
  "mkt.cancel_campaign": "Stop campaign",
  "mkt.stop": "Stop sending",
  "mkt.unschedule": "Unschedule",
  "mkt.stop_body": "Emails already sent stay sent. Nobody else gets this campaign.",
  "mkt.unschedule_body": "The campaign goes back to drafts. You can schedule it again.",
  "mkt.delete_campaign": "Delete campaign?",
  "mkt.delete_campaign_body": "The campaign and its results are deleted. This can't be undone.",
  "mkt.review_send": "Review and send",
  "mkt.results": "Results",
  "mkt.stat.delivered": "Sent",
  "mkt.stat.opened": "Opened",
  "mkt.stat.clicked": "Clicked",
  "mkt.stat.sales": "Sales",
  "mkt.stat.orders": "{n} orders",
  "mkt.stat.queued": "{n} still sending",
  "mkt.results_note": "{unsub} unsubscribed. {failed} weren't sent (unsubscribed, bounced or blocked addresses). Opens are approximate: some email apps hide them. Orders count when placed within 5 days of a click.",
  "mkt.error.quota": "This campaign wasn't sent: the store has used its marketing emails for this month. Upgrade your plan or wait for next month.",
  "mkt.error.no_recipients": "This campaign wasn't sent: no subscribed customers matched the audience at send time.",
  "mkt.campaign_name": "Campaign name",
  "mkt.campaign_name_hint": "Only you see this. It also tags the campaign's links (utm_campaign).",
  "mkt.language": "Language",
  "mkt.audience": "Audience",
  "mkt.audience_hint": "Only customers who agreed to get marketing email are included.",
  "mkt.send_to": "Send to",
  "mkt.all_subscribers": "All subscribers",
  "mkt.exclude_recent": "Leave out recent buyers",
  "mkt.exclude_recent_hint": "Skip customers who ordered in this period.",
  "mkt.exclude_none": "Don't leave anyone out",
  "mkt.exclude_days": "Ordered in the last {n} days",
  "mkt.audience_count": "{n} recipients",
  "mkt.audience_of": "of {n} subscribers",
  "mkt.quota_left": "{n} of {limit} marketing emails left this month",
  "mkt.send_now": "Send now",
  "mkt.schedule_later": "Schedule for later",
  "mkt.schedule": "Schedule",
  "mkt.send_at": "Send at",
  "mkt.send_at_hint": "In your computer's time zone.",
  "mkt.sending_now": "Sending now",
  "mkt.scheduled": "Campaign scheduled",
  "mkt.compliance_note": "Every email has a one-click unsubscribe link and your store address. Unsubscribed and bounced addresses are skipped automatically.",

  // email editor
  "mkt.subject": "Subject",
  "mkt.preheader": "Preview text",
  "mkt.preheader_hint": "Shown after the subject in most inboxes.",
  "mkt.merge_hint": "Personalize with {tags}",
  "mkt.accent": "Button color",
  "mkt.background": "Background",
  "mkt.use_brand": "Use brand color",
  "mkt.content": "Content",
  "mkt.add_block": "Add a block",
  "mkt.move_up": "Move up",
  "mkt.move_down": "Move down",
  "mkt.block.header": "Logo",
  "mkt.block.heading": "Heading",
  "mkt.block.text": "Text",
  "mkt.block.image": "Image",
  "mkt.block.button": "Button",
  "mkt.block.products": "Products",
  "mkt.block.discount": "Discount code",
  "mkt.block.divider": "Divider",
  "mkt.block.social": "Social links",
  "mkt.block.spacer": "Space",
  "mkt.block.header_hint": "Your logo from checkout settings, or your store name, linking to your store.",
  "mkt.block.no_options": "Nothing to set.",
  "mkt.block.heading_default": "Hello {{first_name}}",
  "mkt.block.text_default": "Write your message here.",
  "mkt.block.button_default": "Shop now",
  "mkt.text": "Text",
  "mkt.text_hint": "A blank line starts a new paragraph.",
  "mkt.align": "Alignment",
  "mkt.align.start": "Start",
  "mkt.align.center": "Center",
  "mkt.button_label": "Button label",
  "mkt.link": "Link",
  "mkt.link_hint": "A store path like /collections/new, or a full link.",
  "mkt.alt": "Image description",
  "mkt.alt_hint": "Shown when images are blocked, and read by screen readers.",
  "mkt.choose_image": "Choose image",
  "mkt.upload": "Upload",
  "mkt.search_files": "Search files",
  "mkt.no_files": "No images yet. Upload one.",
  "mkt.columns": "Columns",
  "mkt.products_hint": "Titles, prices and images come from your products when the email is sent.",
  "mkt.code": "Code",
  "mkt.code_hint": "A code from Discounts, or {{discount_code}} for the code an automation issued.",
  "mkt.social.instagram": "Instagram",
  "mkt.social.facebook": "Facebook",
  "mkt.social.x": "X",
  "mkt.social.tiktok": "TikTok",
  "mkt.social.snapchat": "Snapchat",
  "mkt.social.youtube": "YouTube",
  "mkt.social.whatsapp": "WhatsApp",
  "mkt.social.linkedin": "LinkedIn",
  "mkt.social.pinterest": "Pinterest",
  "mkt.preview": "Preview",
  "mkt.desktop": "Desktop",
  "mkt.mobile": "Mobile",
  "mkt.no_subject": "(No subject)",
  "mkt.send_test": "Send test",
  "mkt.send": "Send",
  "mkt.test_to": "Send to",
  "mkt.test_to_hint": "Up to 5 addresses, separated by commas.",
  "mkt.test_note": "Test emails use sample customer details and their links aren't tracked.",
  "mkt.test_sent": "Test email on its way",
  "mkt.done": "Done",

  // automations
  "mkt.flow.create": "Create automation",
  "mkt.flow.untitled": "New automation",
  "mkt.flow.abandoned": "Abandoned checkout reminders",
  "mkt.flow.abandoned_hint": "Up to 3 reminders with an optional discount code. A store feature with its own settings.",
  "mkt.flow.on": "On",
  "mkt.flow.off": "Off",
  "mkt.flow.settings": "Settings",
  "mkt.flow.steps": "{n} steps",
  "mkt.flow.sent": "{n} emails",
  "mkt.flow.in_progress": "{n} in progress",
  "mkt.flow.recipes": "Start from a template",
  "mkt.flow.recipes_hint": "Ready-made automations with emails written for you. Review them, then turn them on.",
  "mkt.flow.status.draft": "Draft",
  "mkt.flow.status.active": "On",
  "mkt.flow.status.paused": "Paused",
  "mkt.flow.activated": "Automation is on",
  "mkt.flow.paused": "Automation paused",
  "mkt.flow.delete": "Delete automation?",
  "mkt.flow.delete_body": "Customers in progress stop here. Its results are deleted.",
  "mkt.flow.turn_on": "Turn on",
  "mkt.flow.runs": "Customers entered",
  "mkt.flow.name": "Name",
  "mkt.flow.trigger": "Starts when",
  "mkt.flow.days_without_order": "Days without an order",
  "mkt.flow.steps_title": "Steps",
  "mkt.flow.blocks": "{n} blocks",
  "mkt.flow.subscribed_only": "subscribers only",
  "mkt.flow.discount_tag_hint": "Add a discount code block with {{discount_code}} to show the code an earlier step issued.",
  "mkt.trigger.customer_subscribed": "A customer subscribes to email marketing",
  "mkt.trigger.first_order": "A customer places their first order",
  "mkt.trigger.order_placed": "A customer places an order",
  "mkt.trigger.order_fulfilled": "An order is fulfilled",
  "mkt.trigger.win_back": "A customer hasn't ordered in {days} days",
  "mkt.trigger.birthday": "It's a customer's birthday",
  "mkt.trigger.customer_subscribed.short": "Customer subscribes",
  "mkt.trigger.first_order.short": "First order",
  "mkt.trigger.order_placed.short": "Order placed",
  "mkt.trigger.order_fulfilled.short": "Order fulfilled",
  "mkt.trigger.win_back.short": "No order for a while",
  "mkt.trigger.birthday.short": "Birthday",
  "mkt.trigger.customer_subscribed.hint": "Runs once per customer, when they agree to get marketing email (checkout, newsletter form, account or import).",
  "mkt.trigger.first_order.hint": "Runs once, for a customer's first order.",
  "mkt.trigger.order_placed.hint": "Runs for every order a customer places.",
  "mkt.trigger.order_fulfilled.hint": "Runs when an order ships.",
  "mkt.trigger.win_back.hint": "Runs once for each customer who passes this many days since their last order.",
  "mkt.trigger.birthday.hint": "Uses the customer's birth date in the facts.birth_date metafield (YYYY-MM-DD). Runs once a year.",
  "mkt.step.wait": "Wait",
  "mkt.step.condition": "Check a condition",
  "mkt.step.send_email": "Send email",
  "mkt.step.add_tag": "Add customer tag",
  "mkt.step.issue_discount": "Create discount code",
  "mkt.step.notify_staff": "Notify staff",
  "mkt.step.tag_placeholder": "Tag, like VIP",
  "mkt.step.percent_off": "% off, valid for",
  "mkt.step.days_valid": "days",
  "mkt.step.discount_hint": "A single-use code just for this customer. Show it in a later email with {{discount_code}}.",
  "mkt.step.staff_placeholder": "What staff see, e.g. {{first_name}} became a VIP",
  "mkt.cond.not_ordered_since_start": "Hasn't ordered since starting",
  "mkt.cond.ordered_since_start": "Has ordered since starting",
  "mkt.cond.is_subscribed": "Is subscribed to email",
  "mkt.cond.orders_count_gte": "Orders at least",
  "mkt.cond.total_spent_gte": "Total spent at least",
  "mkt.cond.has_tag": "Has tag",
  "mkt.cond.not_has_tag": "Doesn't have tag",
  "mkt.cond.stop_hint": "If not, the automation ends for this customer.",
  "mkt.unit.hours": "hours",
  "mkt.unit.days": "days",
  "mkt.edit_email": "Edit email",
  "mkt.view_email": "View email",

  // feeds
  "mkt.feed.add": "Add feed",
  "mkt.feed.empty": "Sell on Google, Instagram, TikTok and Snapchat",
  "mkt.feed.empty_body": "Create a product feed and add its link in Google Merchant Center or your Meta, TikTok or Snapchat catalog. It updates every hour.",
  "mkt.feed.channel": "Channel",
  "mkt.feed.channel.google": "Google Merchant Center",
  "mkt.feed.channel.meta": "Meta (Facebook and Instagram)",
  "mkt.feed.channel.tiktok": "TikTok",
  "mkt.feed.channel.snapchat": "Snapchat",
  "mkt.feed.setup.google": "How to add it in Merchant Center",
  "mkt.feed.setup.meta": "How to add it in Commerce Manager",
  "mkt.feed.setup.tiktok": "How to add it in TikTok catalog",
  "mkt.feed.setup.snapchat": "How to add it in Snapchat catalog",
  "mkt.feed.name": "Name",
  "mkt.feed.country": "Target country",
  "mkt.feed.country_hint": "Where you'll advertise. Prices are in your store currency.",
  "mkt.feed.brand_fallback": "Brand for products without a vendor",
  "mkt.feed.brand_fallback_hint": "Your store name is used when this is empty.",
  "mkt.feed.include_oos": "Include sold-out products",
  "mkt.feed.items": "{n} items",
  "mkt.feed.built": "last fetched {when}",
  "mkt.feed.not_fetched": "not fetched yet",
  "mkt.feed.check": "Check products",
  "mkt.feed.edit": "Edit",
  "mkt.feed.rotate": "New secret link",
  "mkt.feed.rotate_body": "The current link stops working. Update it in the channel afterwards.",
  "mkt.feed.rotated": "New link created",
  "mkt.feed.delete": "Delete feed?",
  "mkt.feed.delete_body": "The channel can no longer read your products from this link.",
  "mkt.feed.note": "Feeds list active products on your online store, one item per variant. Keep the links private.",
  "mkt.feed.check_title": "Check: {name}",
  "mkt.feed.ready": "{ready} of {total} items are ready to show",
  "mkt.feed.examples": "Examples",
  "mkt.feed.issue.missing_image": "No image (rejected)",
  "mkt.feed.issue.missing_price": "No price (rejected)",
  "mkt.feed.issue.missing_description": "No description",
  "mkt.feed.issue.missing_identifiers": "No barcode (GTIN) or SKU",
  "mkt.feed.issue.missing_brand": "No vendor (brand)",
  "mkt.feed.issue.missing_category": "No product category",

  // SEO
  "seo.title": "SEO",
  "seo.description": "Help search engines show your products well.",
  "seo.tab.overview": "Overview",
  "seo.tab.bulk": "Titles and descriptions",
  "seo.tab.alt": "Image alt text",
  "seo.tab.links": "Broken links",
  "seo.rich": "Product rich results",
  "seo.rich_hint": "Products with an image, price and description can show with price and availability in Google.",
  "seo.rich_count": "{n} of {total} active products are eligible.",
  "seo.with_reviews": "{n} also show star ratings.",
  "seo.checks": "What to improve",
  "seo.check.missing_image": "Products without an image",
  "seo.check.missing_description": "Products without a description",
  "seo.check.missing_brand": "Products without a vendor (brand)",
  "seo.check.missing_gtin": "Products without a barcode (GTIN)",
  "seo.check.missing_seo_title": "Products without a page title",
  "seo.check.missing_seo_description": "Products without a meta description",
  "seo.check.images_missing_alt": "Images without alt text",
  "seo.fix": "Fix",
  "seo.more": "More SEO settings",
  "seo.more.preferences": "Preferences",
  "seo.more.preferences_hint": "home page title, social sharing image, Google Search Console verification",
  "seo.more.feeds": "Product feeds",
  "seo.more.feeds_hint": "free product listings on Google Shopping",
  "seo.more.sitemap": "Sitemap and robots.txt",
  "seo.search": "Search products",
  "seo.filter.missing_any": "Missing title or description",
  "seo.filter.missing_title": "Missing page title",
  "seo.filter.missing_description": "Missing meta description",
  "seo.filter.all": "All products",
  "seo.save_n": "Save {n}",
  "seo.saved": "{n} saved",
  "seo.all_done": "Every product here has a page title and description.",
  "seo.page_title": "Page title",
  "seo.meta_description": "Meta description",
  "seo.search_preview": "Search result preview",
  "seo.no_description": "Add a description to show here.",
  "seo.alt_title": "Image alt text",
  "seo.alt_hint": "{missing} of {total} product images have no description.",
  "seo.alt_done": "Every product image has alt text.",
  "seo.alt_label": "Alt text",
  "seo.alt_placeholder": "Describe the image of {product}",
  "seo.links_title": "Broken links",
  "seo.links_hint": "Links in your menus, pages, blog posts and theme that point to pages that don't exist.",
  "seo.check_links": "Check links",
  "seo.check_again": "Check again",
  "seo.links_idle": "Run a check to find links that lead to missing pages.",
  "seo.links_ok": "All {n} links work.",
  "seo.links_found": "{n} broken links out of {checked}.",
  "seo.source.menu": "Menu",
  "seo.source.page": "Page",
  "seo.source.article": "Blog post",
  "seo.source.theme": "Theme",

  // preferences: verification
  "prefs.verification": "Site verification",
  "prefs.verification_hint": "Prove you own the store to Google Search Console, Bing, Meta and others.",
  "prefs.verify.google": "Google Search Console",
  "prefs.verify.bing": "Bing Webmaster Tools",
  "prefs.verify.meta": "Meta (domain verification)",
  "prefs.verify.pinterest": "Pinterest",
  "prefs.verify.tiktok": "TikTok",
  "prefs.verify.yandex": "Yandex",
  "prefs.verify_placeholder": "Paste the meta tag or its content value",
  "prefs.verification_note": "The tags are added to your home page. Choose the HTML tag method in the service.",

  // reports
  "an.report.abandoned_recovery": "Abandoned checkout recovery",
  "an.col.reminded": "Reminded",
  "an.col.clicked": "Clicked",
  "an.col.recovery_rate": "Recovery rate",
  "an.col.recovered_sales": "Recovered sales",
} as const;

export default marketingEn;
